/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { queryAllByAttribute, queryByAttribute } from '@testing-library/preact';
import { expect } from 'chai';

export const queryById = queryByAttribute.bind(null, 'id');

export function queryAllBy(attribute: string) {
  return queryAllByAttribute.bind(null, attribute);
}

export function checkTooltipText(content: string) {
  const targetElements = document.querySelectorAll('[role="tooltip"]');
  const targetElementItem = targetElements.item(0) as HTMLElement;
  const tooltipContainer = targetElementItem?.firstElementChild as HTMLElement;
  expect(tooltipContainer?.style.opacity).not.equals('');
  expect(tooltipContainer?.style.opacity).not.equals('0');
  expect(tooltipContainer?.style.maxHeight).not.equals('');
  expect(tooltipContainer?.style.maxHeight).not.equals('0');
  const innerHTML = tooltipContainer?.firstElementChild?.innerHTML;
  expect(innerHTML).equals(content);
}
